<template>
  <div id="app">
    <div class="opencc-main">
      <h1>数字钱包地址识别工具</h1>
      <div class="row">
        <div class="col-md-6 m-b-10"></div>
        <div class="col-md-6 m-b-10">
        <button class="btn btn-info btn-w-xl m-5 btnClipboard" type="button" data-clipboard-action="copy" data-clipboard-target="#textClipboard"><i class="mdi mdi-content-copy"></i> 复制结果</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 m-b-10">
          <textarea class="form-control border-info" placeholder="输入钱包地址（一行一个）.." auto-height rows="6" v-model="inputText" ref="intextarea" :style="{'height': height}"></textarea>
          <div class="help-block">在左边输入要校验的钱包地址（一行一个），右边自动输出识别结果..</div>
        </div>
        <div class="col-md-6 m-b-10">
          <textarea class="form-control"  placeholder="校验输出.." auto-height readonly rows="6" id="textClipboard" v-model="outputText" :style="{'height': height}"></textarea>
        </div>
      </div>
      <div class="alert alert-warning alert-kepu">
        <p><strong>钱包地址</strong></p>
        <p>钱包地址相当于一个收款帐号，数字钱包种类简称“币种”越来越多，当您收到一个钱包地址时应该校验一下正确性</p>
        <p>声明：此类数字货币非国内合法货币，本工具仅提供给大家了解学习，检验结果仅供参考</p>
        <p>
          测试钱包地址：<br/>
          12QeMLzSrB8XH8FvEzPMVoRxVAzTr5XM2y<br/>
          0xAff4d6793F584a473348EbA058deb8caad77a288<br/>
          DPS6iZj7roHquvwRYXNBua9QtKPzigUUhM
        </p>
        <p><i class="mdi mdi-24px mdi-spin mdi-currency-btc"></i> <strong>支持钱包</strong></p>
        <p>
          <table class="table table-bordered table-hover wallet-table">
            <tr class="info">
              <th>英文</th>
              <th>简称</th>
              <th>中文名</th>
           </tr>
           <tr v-for="wallet in walletList">
              <td>{{wallet.name}}</td>
              <td>{{wallet.coin}}</td>
              <td>{{wallet.text}}</td>
           </tr>
          </table>
        </p>
      </div>
    
    </div>
  </div>
</template>

<script>


// import Vue from 'vue';
import Clipboard from 'clipboard';
import calcTextareaHeight from './assets/calcTextareaHeight.js';

var WAValidator = require('wallet-address-validator');





export default {
  name: 'App',
  components: {
    Clipboard
  },
  data:function() {

		return {
      height: '150px',
      walletList:[
        {name:'Bitcoin',coin:'BTC',text:'比特币'},
        {name:'BitcoinCash',coin:'BCH',text:'比特币现金'},
        {name:'BitcoinGold',coin:'BTG',text:'比特币黄金'},
        {name:'BitcoinPrivate',coin:'BTCP',text:''},
        {name:'BitcoinZ',coin:'BTCZ',text:''},
        {name:'Ethereum',coin:'ETH',text:'以太坊'},
        {name:'EthereumClassic',coin:'ETC',text:'以太坊经典'},
        {name:'EthereumZero',coin:'ETZ',text:''},
        {name:'Litecoin',coin:'LTC',text:'莱特币'},
        {name:'Dogecoin',coin:'DOGE',text:'狗币'},
        {name:'Auroracoin',coin:'AUR',text:'极光币'},
        {name:'Bankex',coin:'BKX',text:''},
        {name:'BeaverCoin',coin:'BVC',text:''},
        {name:'Biocoin',coin:'BIO',text:''},
        {name:'Callisto',coin:'CLO',text:''},
        {name:'Dash',coin:'DASH',text:'达世币'},
        {name:'Decred',coin:'DCR',text:'德信币'},
        {name:'Freicoin',coin:'FRC',text:'运输币'},
        {name:'Garlicoin',coin:'GRLC',text:''},
        {name:'Hush',coin:'HUSH',text:''},
        {name:'Komodo',coin:'KMD',text:'科莫多币'},
        {name:'Megacoin',coin:'MEC',text:'美卡币'},
        {name:'Monero',coin:'XMR',text:'门罗币'},
        {name:'Namecoin',coin:'NMC',text:''},
        {name:'Nano',coin:'NANO',text:''},
        {name:'NEO',coin:'NEO',text:''},
        {name:'NeoGas',coin:'GAS',text:'小蚁币'},
        {name:'Peercoin/PPCoin',coin:'PPC',text:'点点币'},
        {name:'Primecoin',coin:'XPM',text:'质数币'},
        {name:'Protoshares',coin:'PTS',text:''},
        {name:'Qtum',coin:'QTUM',text:''},
        {name:'Raiblocks',coin:'XRB',text:'源石币'},
        {name:'Ripple',coin:'XRP',text:'瑞波币'},
        {name:'Snowgem',coin:'SNG',text:''},
        {name:'Vertcoin',coin:'VTC',text:'绿币'},
        {name:'Zcash',coin:'ZEC',text:''},
        {name:'Zclassic',coin:'ZCL',text:'归零币'},
        {name:'ZenCash',coin:'ZEN',text:''}
      ],
      inputSelect:config.inputSelect || 'cn',
      outputSelect:config.outputSelect ||'hk',
      inputText:'',
      outputText:''
		};
	},
  watch: {
    inputText() {
      this.getHeight();
      this.convert();
    },
    inputSelect(){
      this.convert();
    },
    outputSelect(){
      console.log(3);
      this.convert();
    }
  },
	mounted:function(){
    //bind domain
    // if(!location.hostname.match(/ima.co/) && !location.hostname.match(/zqrcode.c/) && !location.hostname.match(/zqrhk.c/)){
    //   location.href = 'https://www.2weima.com/?diysafe='+ encodeURIComponent(location.href);
    //   $('body').html('');
    //   return ;
    // }
  Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();
    this.$nextTick(() => {
      this.init();
    });


	},
	methods: {
    getHeight() {
    
      var height = calcTextareaHeight(this.$refs.intextarea, 6, null).height;
      
      this.height  = height < 150 ? 150 : height;
    },
		init:function(){
    
      var clipboard = new Clipboard('.btnClipboard');

			clipboard.on('success', function(e) {
        $common.showNotify('复制成功','success');
				e.clearSelection();
			});
			clipboard.on('error', function(e) {
        $common.showNotify('复制失败，浏览器不支持，请手工复制','warning');
			});

		},
    convert:function(){
      var inputArr = this.inputText.split("\n");
      var outputArr = [];
      var outputArrAll = [];
      var isValid = false;
      for(var i in inputArr){
          if(!inputArr[i]){
            continue;
          }
          isValid= false;
          outputArr[i] = [];
          for(var j in this.walletList){
              var valid = WAValidator.validate(inputArr[i], this.walletList[j].coin);
              if(valid){
                  isValid= true;
                  outputArr[i].push(this.walletList[j].coin );//+'/'+ this.walletList[j].text
                  // break;
              }
          }
          if(!isValid){
            outputArr[i].push('未知');
          }
          outputArrAll.push(inputArr[i] +' => ' + outputArr[i].join(' 或 '));
      }

      // console.log(outputArrAll);
      this.outputText = outputArrAll.join("\r\n");

    }
    
	}
}
</script>


<style scoped>
.opencc-main h1{
 font-size:22px;
 margin-bottom: 20px;
}
.alert-kepu{
  margin-top:50px;
}
.border-success{
  border:1px solid #15c377;
}
.border-info{
  border:1px solid #48b0f7;
}

.wallet-table {
    border-color: #3da0d2;
    background: #fff;;
}
.wallet-table tr, .wallet-table td,.wallet-table th{
  border:1px solid #3da0d2;
  text-align: center;
  padding:10px 0;
}
</style>
